// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  width: 46%;
  flex-shrink: 0;
  flex-grow: 1;
}

.input-label {
  color: var(--secondary-text-color);
  font-family: "Medium Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 125%; /* 17.5px */
}

.required {
  color: #ef5054;
}

.select-wrapper {
  position: relative;
  width: 100%;
}

.select-field {
  display: flex;
  padding: 0px 16px;
  padding-right: 32px;
  align-items: center;
  color: var(--primary-text-color);
  height: 44px;
  gap: 10px;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid var(--border-color);
  width: 100%;
  background-color: var(--primary-surface-color);
  font-family: "Medium Sans";
  font-size: 14px;
  font-weight: 500;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}
.select-field::placeholder {
  color: var(--primary-text-color);
  font-family: "Medium Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 125%; /* 17.5px */
}
.select-field:disabled {
  background-color: #f5f5f5;
  color: #94a0b3;
  cursor: not-allowed;
  opacity: 0.6;
  border-color: #e0e0e0;
}
.select-field:focus {
  border: 2px solid #5095fc;
  outline: none;
}

.select-wrapper::after {
  content: "";
  position: absolute;
  top: 40%;
  right: 16px;
  pointer-events: none;
  width: 6px;
  height: 6px;
  border: 1px solid var(--tertiary-text-color);
  border-width: 0 1px 1px 0;
  transform: rotate(45deg);
  background-color: transparent;
}

.select-error {
  border-color: #e34935;
}

.error-message {
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  color: #e34935;
}

.select-option {
  font-family: "Medium Sans";
  font-size: 14px;
  font-weight: 500;
  line-height: 125%;
  color: var(--secondary-text-color);
}`, "",{"version":3,"sources":["webpack://./src/components/Forms/Inputs/selectInput.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,UAAA;EACA,cAAA;EACA,YAAA;AACJ;;AAEE;EACE,kCAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AACJ;;AAEE;EACE,cAAA;AACJ;;AAEE;EACE,kBAAA;EACA,WAAA;AACJ;;AAEE;EACE,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gCAAA;EACA,YAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,qCAAA;EACA,WAAA;EACA,8CAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,wBAAA;EACA,qBAAA;AACJ;AAAI;EACE,gCAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AAEN;AAAI;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,YAAA;EACA,qBAAA;AAEN;AAAI;EACE,yBAAA;EACA,aAAA;AAEN;;AAEE;EACE,WAAA;EACF,kBAAA;EACA,QAAA;EACA,WAAA;EAEA,oBAAA;EACA,UAAA;EACA,WAAA;EACA,4CAAA;EACA,yBAAA;EACA,wBAAA;EACA,6BAAA;AAAF;;AAIE;EACE,qBAAA;AADJ;;AAIE;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AADJ;;AAIE;EACE,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kCAAA;AADJ","sourcesContent":[".input-container {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n    width:46%;\n    flex-shrink: 0;\n    flex-grow: 1;\n  }\n  \n  .input-label {\n    color: var(--secondary-text-color);\n    font-family: 'Medium Sans';\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 125%; /* 17.5px */\n  }\n  \n  .required {\n    color: #ef5054;\n  }\n  \n  .select-wrapper {\n    position: relative;\n    width: 100%;\n  }\n  \n  .select-field {\n    display: flex;\n    padding: 0px 16px;\n    padding-right: 32px;\n    align-items: center;\n    color: var(--primary-text-color);\n    height: 44px;\n    gap: 10px;\n    align-self: stretch;\n    border-radius: 8px;\n    border: 1px solid var(--border-color);\n    width: 100%;\n    background-color: var(--primary-surface-color);\n    font-family: 'Medium Sans';\n    font-size: 14px;\n    font-weight: 500;\n    appearance: none;  // Hide the default arrow\n    -webkit-appearance: none;  // For Safari\n    -moz-appearance: none;  // \n    &::placeholder {\n      color: var(--primary-text-color);\n      font-family: 'Medium Sans';\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: 125%; /* 17.5px */\n    }\n    &:disabled {\n      background-color: #f5f5f5;\n      color: #94a0b3;\n      cursor: not-allowed;\n      opacity: 0.6;\n      border-color: #e0e0e0;\n    }\n    &:focus {\n      border: 2px solid  #5095fc;\n      outline: none;\n    }\n  }\n\n  .select-wrapper::after {\n    content: '';\n  position: absolute;\n  top: 40%;\n  right: 16px; // Adjust the position of the custom arrow\n  // transform: translateY(-50%);\n  pointer-events: none;\n  width: 6px;\n  height: 6px;\n  border: 1px solid var(--tertiary-text-color); // Arrow color\n  border-width: 0 1px 1px 0;\n  transform: rotate(45deg);\n  background-color: transparent;\n  }\n  \n  \n  .select-error {\n    border-color: #e34935;\n  }\n  \n  .error-message {\n    font-style: normal;\n    font-weight: 600;\n    font-size: 12px;\n    color: #e34935;\n  }\n  \n  .select-option {\n    font-family: 'Medium Sans';\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 125%;\n    color: var(--secondary-text-color);\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
